import React, { useContext } from "react";
import { PlayerAction } from "../../../types";
import Waitable from "../../common/waitable/waitable";
import { GameStatus } from "../../../types/game-status";
import FormPage from "../../common/formpage/formpage";
import { useTranslation } from "react-i18next";
import { useWaitableForm } from "../../../hooks/useWaitableForm";
import CharacterSubmitBase from "./character-submit-base";
import { useCharacterSubmit } from "./useCharacterSubmit";
import { GameContext } from "../../../contexts";

const CharacterSubmit = () => {
  const { t } = useTranslation(["game", "common"]);
  const { submit } = useContext(GameContext);
  const {
    sortedCharacters,
    characterNames,
    characterMaturities,
    settings,
    subHeaders,
    submitText,
    titles,
    handleChange,
    handleMature,
    createPlayerAction,
    isReady,
  } = useCharacterSubmit();

  const { waitableProps, formPageProps } = useWaitableForm({
    gameSubmit: createPlayerAction,
    waitingFor: [GameStatus.GameStatusPostCharacters],
    waitHeader: t("characterSubmit.headers.waiting"),
    titles,
    submitText,
    validation: { isReady },
    subHeaders,
  });

  return (
    <Waitable playerActionHandler={submit} {...waitableProps}>
      <FormPage {...formPageProps}>
        <CharacterSubmitBase
          characters={sortedCharacters}
          characterNames={characterNames}
          characterMaturities={characterMaturities}
          showCharacterMaturity={settings.character_maturity}
          onNameChange={handleChange}
          onMatureChange={handleMature}
        />
      </FormPage>
    </Waitable>
  );
};

export default CharacterSubmit;
